module.exports = "<span class=\"snack-bar\">\n  {{data}}\n</span>"